import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[80vh] flex items-center justify-center overflow-hidden bg-navy-950 text-white px-4 py-12" data-id="element-101">
      {/* Background subtle gradient/pattern */}
      <div className="absolute inset-0 opacity-20 pointer-events-none" data-id="element-102">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-gold-500 rounded-full mix-blend-multiply filter blur-[128px] animate-pulse" data-id="element-103" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-navy-400 rounded-full mix-blend-multiply filter blur-[128px]" data-id="element-104" />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center" data-id="element-105">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-106">
          <span className="inline-block py-1.5 px-4 rounded-full bg-gold-500/10 text-gold-300 text-xs font-bold tracking-[0.2em] uppercase mb-8 border border-gold-500/20" data-id="element-107">
            El Triángulo Roto
          </span>
        </motion.div>

        <motion.h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-8" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-108">
          Una sesión privada para ordenar tu relación con Dios, con el dinero y
          contigo mismo.
        </motion.h1>

        <motion.div className="text-lg md:text-xl text-navy-200 mb-12 space-y-4 font-light leading-relaxed max-w-2xl mx-auto" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} data-id="element-109">
          <p data-id="element-110">Hay momentos en los que el problema no es externo.</p>
          <p data-id="element-111">
            No es falta de capacidad. No es falta de intención. No es falta de
            fe.
          </p>
          <p className="text-white font-medium" data-id="element-112">Es desorden en la raíz.</p>
          <p data-id="element-113">
            Una fractura interna que termina afectando tres áreas esenciales de
            tu vida:{' '}
            <span className="text-gold-300" data-id="element-114">Dios. Dinero. Identidad.</span>
          </p>
          <p data-id="element-115">
            Y cuando esas tres áreas entran en conflicto, lo demás empieza a
            perder fuerza: culpa, confusión, autosabotaje, desgaste, repetición.
          </p>
          <p className="pt-4 text-white" data-id="element-116">
            El Triángulo Roto es una sesión privada para identificar esa raíz
            con claridad y comenzar a restaurar orden donde hoy hay ruido.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="mb-12 flex justify-center" data-id="element-117">
          <div className="inline-flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-sm text-navy-300 uppercase tracking-widest font-medium" data-id="element-118">
            <span data-id="element-119">Sesión privada</span>
            <span className="text-gold-500/50" data-id="element-120">·</span>
            <span data-id="element-121">60 minutos</span>
            <span className="text-gold-500/50" data-id="element-122">·</span>
            <span data-id="element-123">Dirección personalizada</span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.7
      }} data-id="element-124">
          <div className="mb-8 inline-flex flex-col items-center gap-1" data-id="element-125">
            <p className="text-navy-300 text-sm" data-id="element-126">
              Valor referencial:{' '}
              <span className="line-through text-navy-400" data-id="element-127">$397 USD</span>
            </p>
            <p className="text-xl md:text-2xl font-serif text-white mt-1" data-id="element-128">
              Inversión de lanzamiento:{' '}
              <span className="text-gold-400 font-bold" data-id="element-129">$33 USD</span>
            </p>
            <p className="text-xs text-navy-400 uppercase tracking-widest mt-3 font-bold" data-id="element-130">
              Acceso limitado
            </p>
          </div>

          <div data-id="element-131">
            <a href="#cta-final" className="inline-flex items-center justify-center gap-3 bg-gold-500 hover:bg-gold-400 text-navy-950 px-8 py-4 rounded-full text-lg font-bold transition-all duration-300 transform hover:scale-105 shadow-[0_0_40px_-10px_rgba(211,154,34,0.3)]" data-id="element-132">
              QUIERO RESERVAR MI ESPACIO
              <ArrowRight className="w-5 h-5" data-id="element-133" />
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}